export const thumbnailProgramEntry = {
  fields: [
    'date_time_start',
    'date_time_end',
    'is_main_exhibition'
  ],
  populate: {
    titles: true,
    slugs: true,
    tags: true,
    introductions: true,
    cover_image: true,
    date_time_ranges: true,
    opening_date_time: true,
    program_entries: {
      sort: ['date_time_start:desc', 'date_time_end:asc'],
      fields: [
        'date_time_start',
        'date_time_end'
      ],
      populate: {
        titles: true,
        slugs: true,
        tags: true,
        introductions: true,
        cover_image: true,
        date_time_ranges: true,
      }
    }
  }
}
